import React, { useMemo } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import { observer } from 'mobx-react';

const BasketballViewRegular = observer(({ quarter, item }) => {
  const {
    sortedHomeScores,
    sortedAwayScores,
    period,
    periodSpecial,
    getTracker
  } = item;

  const score = useMemo(() => {
    let result = {
      home: '',
      away: ''
    };

    if (quarter.value > 4) {
      if (sortedHomeScores.length > 0) {
        const homeScoreArr = sortedHomeScores.filter(
          (score) => score.period > 4
        );

        if (homeScoreArr.length > 0) {
          result.home = homeScoreArr.reduce((a, c) => a + c.score, 0);
        }
      }

      if (sortedAwayScores.length > 0) {
        const awayScoreArr = sortedAwayScores.filter(
          (score) => score.period > 4
        );

        if (awayScoreArr.length > 0) {
          result.away = awayScoreArr.reduce((a, c) => a + c.score, 0);
        }
      }
    } else {
      if (sortedHomeScores.length > 0) {
        const homeScoreArr = sortedHomeScores.filter(
          (score) => quarter.value === score.period
        );

        if (homeScoreArr.length > 0) {
          result.home = homeScoreArr[0].score;
        }
      }

      if (sortedAwayScores.length > 0) {
        const awayScoreArr = sortedAwayScores.filter(
          (score) => quarter.value === score.period
        );

        if (awayScoreArr.length > 0) {
          result.away = awayScoreArr[0].score;
        }
      }
    }

    return result;
  }, [quarter, sortedHomeScores, sortedAwayScores]);

  const special = useMemo(() => {
    const matchSpecial = periodSpecial.filter(
      (special) => quarter.value === special.period
    )[0];
    let result = {
      home: {
        firstFive: false,
        firstFreeThrow: false,
        firstPoint: false,
        firstSeven: false,
        firstTen: false,
        firstThreePoint: false
      },
      away: {
        firstFive: false,
        firstFreeThrow: false,
        firstPoint: false,
        firstSeven: false,
        firstTen: false,
        firstThreePoint: false
      }
    };

    if (!!matchSpecial) {
      Object.keys(matchSpecial).forEach((key) => {
        if (key !== 'period') {
          if (matchSpecial.hasOwnProperty(key)) {
            if (!!matchSpecial[key]) {
              result[matchSpecial[key].toLowerCase()][key] = true;
            }
          }
        }
      });
    }

    return result;
  }, [periodSpecial, quarter]);

  return (
    <dl
      className={clsx(
        style.item,
        quarter.value === period &&
          getTracker.status === 'progress' &&
          style.on,
        quarter.value > 4 && style.notSpecial,
        quarter.value === 5 &&
          period > 4 &&
          getTracker.status === 'progress' &&
          style.on
      )}
    >
      <dt>{quarter.key}</dt>
      <dd>
        {score.away}
        <span className={style.special}>
          {special.away.firstPoint && <em className={style.s_first}>득</em>}
          {special.away.firstThreePoint && (
            <em className={style.s_three}>삼</em>
          )}
          {special.away.firstFreeThrow && <em className={style.s_free}>자</em>}
          {special.away.firstFive && <em className={style.s_5}>5</em>}
          {special.away.firstSeven && <em className={style.s_7}>7</em>}
          {special.away.firstTen && <em className={style.s_10}>10</em>}
        </span>
      </dd>
      <dd>
        {score.home}
        <span className={style.special}>
          {special.home.firstPoint && <em className={style.s_first}>득</em>}
          {special.home.firstThreePoint && (
            <em className={style.s_three}>삼</em>
          )}
          {special.home.firstFreeThrow && <em className={style.s_free}>자</em>}
          {special.home.firstFive && <em className={style.s_5}>5</em>}
          {special.home.firstSeven && <em className={style.s_7}>7</em>}
          {special.home.firstTen && <em className={style.s_10}>10</em>}
        </span>
      </dd>

      <dd className={style.sum}>{score.home + score.away}</dd>
    </dl>
  );
});

export default BasketballViewRegular;
